module.exports = __webpack_public_path__ + "assets/img/benefit-more-44e43fb2.png";